/**
 * Valeurs par défaut si GET /admin/segments/ui-catalog est indisponible.
 * Le comportement UI reste identique au hardcodé actuel.
 */
export const SEGMENT_UI_DEFAULTS = {
    list: {
        providerFilterLabel: "Origine",
        unomiSyncFailedHint: "La synchronisation CDP a échoué — liste locale affichée. Réessayez ou utilisez sync_unomi=false pour un chargement rapide.",
    },
    delete: {
        blockedHint: "Ce segment est référencé par {rules} règle(s) et {jobs} job(s). Retirez-le de ces configurations avant suppression.",
        unomiWarning: "Le segment sera aussi supprimé dans Apache Unomi.",
    },
    members: {
        refreshLabel: "Actualiser",
        refreshTooltip: "Recalcule les membres du segment (moteur fidélité) puis recharge cette liste — équivalent à un recompute.",
        verifyLabel: "Vérifier conditions",
        verifyTooltip: "Vérifie, pour chaque membre affiché, s'il respecte encore les conditions aujourd'hui (sans recalcul complet).",
        syncUnomiLabel: "Resync Unomi",
        dynamicAstHint: "Segment dynamique : la liste est calculée par le moteur (pas d'ajout manuel). « Actualiser » relance le calcul ; « Vérifier conditions » contrôle l'adéquation actuelle.",
        dynamicUnomiOnlyHint: "Segment dynamique CDP only : les membres sont évalués dans Unomi (conditions non traduisibles en AST loyalty). Cette liste est une lecture du moteur après synchro CDP — pas d'ajout manuel ni de recalcul AST.",
        unomiOnlyBanner: "Segment importé du CDP (badge CDP only). Les membres affichés proviennent de la synchronisation moteur ↔ Unomi.",
        refreshedSuccess: "Liste recalculée à l'instant.",
        verifyMismatch: "{count} membre(s) sur cette page ne respectent plus les conditions actuelles.",
        verifyOk: "Tous les membres de cette page respectent les conditions.",
        cdpWithoutEngineHint: "Profil CDP sans fiche loyalty",
    },
    badges: {
        unomiOnly: "CDP only",
        referenced: "Référencé",
        providerInternal: "Moteur fidélité",
        providerUnomi: "CDP Unomi",
    },
    recompute: {
        tooltip: "Recalcul rapide (POST recompute)",
    },
};

function pickString(catalogValue, fallback) {
    return typeof catalogValue === "string" && catalogValue.trim() ? catalogValue : fallback;
}

/** Fusionne le catalogue API avec les défauts — toujours un objet complet. */
export function resolveSegmentsUi(catalog) {
    const list = catalog?.list || {};
    const del = catalog?.delete || catalog?.workflows?.delete || {};
    const members = catalog?.members || catalog?.workflows?.members || {};
    const badges = catalog?.badges || {};
    const recompute = catalog?.recompute || catalog?.workflows?.recompute || {};

    return {
        list: {
            providerFilterLabel: pickString(list.providerFilterLabel, SEGMENT_UI_DEFAULTS.list.providerFilterLabel),
            unomiSyncFailedHint: pickString(list.unomiSyncFailedHint, SEGMENT_UI_DEFAULTS.list.unomiSyncFailedHint),
        },
        delete: {
            blockedHint: pickString(del.blockedHint || del.messageWhenReferenced, SEGMENT_UI_DEFAULTS.delete.blockedHint),
            unomiWarning: pickString(del.unomiWarning || del.unomiDeleteHint, SEGMENT_UI_DEFAULTS.delete.unomiWarning),
        },
        members: {
            refreshLabel: pickString(members.refreshLabel, SEGMENT_UI_DEFAULTS.members.refreshLabel),
            refreshTooltip: pickString(members.refreshTooltip, SEGMENT_UI_DEFAULTS.members.refreshTooltip),
            verifyLabel: pickString(members.verifyLabel, SEGMENT_UI_DEFAULTS.members.verifyLabel),
            verifyTooltip: pickString(members.verifyTooltip, SEGMENT_UI_DEFAULTS.members.verifyTooltip),
            syncUnomiLabel: pickString(members.syncUnomiLabel, SEGMENT_UI_DEFAULTS.members.syncUnomiLabel),
            dynamicAstHint: pickString(members.dynamicAstHint, SEGMENT_UI_DEFAULTS.members.dynamicAstHint),
            dynamicUnomiOnlyHint: pickString(members.dynamicUnomiOnlyHint, SEGMENT_UI_DEFAULTS.members.dynamicUnomiOnlyHint),
            unomiOnlyBanner: pickString(members.unomiOnlyBanner, SEGMENT_UI_DEFAULTS.members.unomiOnlyBanner),
            refreshedSuccess: pickString(members.refreshedSuccess, SEGMENT_UI_DEFAULTS.members.refreshedSuccess),
            verifyMismatch: pickString(members.verifyMismatch, SEGMENT_UI_DEFAULTS.members.verifyMismatch),
            verifyOk: pickString(members.verifyOk, SEGMENT_UI_DEFAULTS.members.verifyOk),
            cdpWithoutEngineHint: pickString(members.cdpWithoutEngineHint, SEGMENT_UI_DEFAULTS.members.cdpWithoutEngineHint),
        },
        badges: {
            unomiOnly: pickString(badges.unomiOnly, SEGMENT_UI_DEFAULTS.badges.unomiOnly),
            referenced: pickString(badges.referenced, SEGMENT_UI_DEFAULTS.badges.referenced),
            providerInternal: pickString(badges.providerInternal, SEGMENT_UI_DEFAULTS.badges.providerInternal),
            providerUnomi: pickString(badges.providerUnomi, SEGMENT_UI_DEFAULTS.badges.providerUnomi),
        },
        recompute: {
            tooltip: pickString(recompute.tooltip, SEGMENT_UI_DEFAULTS.recompute.tooltip),
        },
    };
}

/** Remplace {rules}, {jobs}, {count} dans les modèles texte. */
export function formatSegmentUiTemplate(template, vars = {}) {
    return String(template || "").replace(/\{(\w+)\}/g, (_, key) => {
        const v = vars[key];
        return v != null ? String(v) : "";
    });
}
